/**
 * printRequestLimits — 인쇄 데이터 요청의 묶음 크기·상한(단일 출처).
 *
 * 서버가 한 번에 받는 문제 수가 경로마다 다르다(백엔드 origin/dev 2026-10-18 기준, 넘으면 400).
 *  - /api/problems/print 200 · /api/solutions/answers 200 · /api/solutions/list 100
 * 이 값을 넘는 시험지도 인쇄되도록 프런트에서 나눠 보낸다. 묶음 크기 이하이면 종전과 같은 요청 한 번이다.
 */
export const PRINT_BODY_BATCH = 200;
export const PRINT_ANSWER_BATCH = 200;
export const SOLUTION_LIST_BATCH = 100;

// 문제별 풀이 상세를 동시에 보내는 수 — 운영 서버 워커가 2개뿐이라 다른 사용자 요청이 밀리지 않게 줄인다
export const SOLUTION_DETAIL_CONCURRENCY = 4;
// 풀이 요청이 연달아 이만큼 실패하면 남은 요청을 보내지 않는다 — 토큰 만료·서버 장애 때 수백 번 두드리지 않게
export const SOLUTION_STOP_AFTER_FAILURES = 5;

// 한 번에 인쇄할 수 있는 문제 수(오너 결정 2026-10-31) — 서버 제한이 아니라 제품 상한이다
export const PRINT_MAX_PROBLEMS = 500;

export function printLimitMessage(count) {
  return `${PRINT_MAX_PROBLEMS}문제까지 인쇄할 수 있습니다. 지금은 ${count}문제입니다.`;
}

/** 순서를 유지한 채 size 개씩 나눈다. */
export function chunkIds(ids, size) {
  const chunks = [];
  for (let i = 0; i < ids.length; i += size) {
    chunks.push(ids.slice(i, i + size));
  }
  return chunks;
}

/**
 * 동시에 limit 개까지만 worker 를 돌리고, 결과는 입력 순서로 돌려준다.
 * 실패 처리는 worker 몫이다 — 항목별로 실패를 담아 돌려주면 한 건이 나머지를 멈추지 않는다.
 */
export async function mapWithLimit(items, limit, worker) {
  const results = new Array(items.length);
  let next = 0;
  const run = async () => {
    while (next < items.length) {
      const index = next;
      next += 1;
      // 앞 요청이 끝나야 다음을 보내는 것이 이 함수의 목적이다
      results[index] = await worker(items[index], index);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, () => run()));
  return results;
}
